// extracted by mini-css-extract-plugin
export default {"confirmModal":"document-modal_confirmModal__9BeMH"};